import React from 'react';
import { connect } from 'dva';
import { Drawer, Modal, Popover, Button, Spin, Select, Row, Col } from 'antd';
import request from 'superagent';
import BaseComponent from '../../../components/BaseComponent';
import Dimio, {DimioNotice} from '../../../components/Dimio';
//import DimioModal from '../../../components/DimioModal';
import DimioSlidein from '../../../components/DimioSlidein';
import ContactForm from '../../contact/components/ContactForm';
import CounsellingItem from './CounsellingItem';
import CounsellingDetail from './CounsellingDetail';
import CounsellingMain from './CounsellingMain';
//import {isMobile} from 'react-device-detect';
import _ from 'lodash';

import '../style/school.scss';

const {Option} = Select;
const NOI = 3;

/**
 * type: loader - loading item by NOI
 */
class CounsellingPage extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      noi:NOI
    };

//    this.showEnquiry = this.showEnquiry.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.filterStatus = this.filterStatus.bind(this);
    this.filterVisa = this.filterVisa.bind(this);
    this.filterType = this.filterType.bind(this);
  }

  componentWillMount() {
    const {dispatch, school} = this.props;
//console.info(school);
    this.showLoading();
    const url = '/data/school-counselling';
//    const url = 'https://tora-tora.net/data/school-counselling';

    const type = (school.counselling_type === 'detail')?1:0;
    const query = {school_id: (school.school_id)?school.school_id:type};
    const self = this;

    if(url) {
      request
        .get(url)
        .query(query)
        .type('json')
//        .then(Dimio.apiResponse)
        .then(response => {
          dispatch({
            type: 'school/setCounselling',
            items: response.body.data,
            meta: response.body.meta,
          });
          self.hideLoading();
//          self.setState({loading:false});
        })
        .catch(err => {
          throw err
        });
    }else{
      throw "URL is not specified";
    }
  }
/*
  showEnquiry(item, index, e){
    e.preventDefault();
    const {dispatch} = this.props;
//    const selected = item
    this.showModal('enquiry');
  }
*/
  loadMore(){
    const {csItems} = this.props.school;
    let noi = this.state.noi;

    if(csItems){
      noi = noi + 3;
      if(noi > csItems.length){
        noi = csItems.length;
      }
    }
    this.setState({noi: noi});
  }

  filterStatus(value){
    const {dispatch} = this.props;

    console.info(value);
    dispatch({
      type: 'school/filterStatus',
      value: value
    });
  }

  filterVisa(value){
    const {dispatch} = this.props;

    console.info(value);
    dispatch({
      type: 'school/filterVisa',
      value: value
    });
  }

  filterType(value){
    const {dispatch} = this.props;
    console.info(value);
    dispatch({
      type: 'school/filterSchoolType',
      value: value
    });
  }

  render() {
    const { school} = this.props;
    const {csItems, csMeta, selectedItem, counselling_type} = school;
    const subItems = [];

    console.info(selectedItem);
    if(selectedItem){
      this.panel.openPanel();
    }

    const Controller = () => (
      <section>
        {csMeta &&
        <div>
          <Select
            style={{width: 240}}
            placeholder="現在のビザ"
            defaultValue={school.filterStatus}
            optionFilterProp="children"
            onChange={this.filterStatus}
            //          onFocus={handleFocus}
            //          onBlur={handleBlur}
          >
            <Option value='all' key='all'>すべて</Option>
            {csMeta.status.map(status => (
              <Option value={status.value} key={status.value}>{status.key}</Option>
            ))}
          </Select>

          <Select
            style={{width: 240}}
            placeholder="更新されたビザ"
            defaultValue={school.filterVisa}
            optionFilterProp="children"
            onChange={this.filterVisa}
            //          onFocus={handleFocus}
            //          onBlur={handleBlur}
          >
            <Option value='all' key='all'>すべて</Option>
            {csMeta.status.map(status => (
              <Option value={status.value} key={status.value}>{status.key}</Option>
            ))}
          </Select>

          <Select
            style={{width: 240}}
            placeholder="学校のタイプ"
//            defaultValue={school.filterVisa}
            optionFilterProp="children"
            onChange={this.filterType}
            //          onFocus={handleFocus}
            //          onBlur={handleBlur}
          >
            <Option value='all' key='all'>すべて</Option>
            {csMeta.school_type.map(t => (
              <Option value={t.value} key={t.value}>{t.key}</Option>
            ))}
          </Select>

        </div>
        }
      </section>
    );

    // load
    if(csItems && csItems.size > 0){
      csItems.map((item,i) => {
        subItems.push(<Col sm={12} key={i}><CounsellingItem item={item} index={i} key={i} type='item'/></Col>);
      });

      /*
      for (let i=1; i < csItems.size; i++) {
        subItems.push(<Col sm={12}><CounsellingItem item={csItems.get(i)} index={i} key={i}/></Col>);
      }
      */
    }

    return (
      <section className="section-counselling">
        <DimioNotice {...school} />
        {/* <LoadingSpinner {...meta} /> */}

        {/* counselling_type != 'detail' &&
        <Controller/>
        */}

        {csItems &&
        <div>
          <Row type="flex" className="section-counselling__hero">
            <Col xs={24} lg={12}>
              <div className="section-counselling__hero_item"
              style={{backgroundSize:'cover',backgroundImage: `url("https://tora-tora.net/${csItems.get(0).get('school_thumb')}")`}}>
                <div className="section-counselling__hero_item" style={{width:'100%'}}>
                  <CounsellingItem item={csItems.get(0)} index={0} type='main' />
                </div>
              </div>
            </Col>
            <Col xs={24} lg={12}>
              <Row type="flex" className="section-counselling__row">
                {subItems}
              </Row>
            </Col>
          </Row>

          {/* counselling_type == 'detail' && items.length > 2 &&
          <Row type="flex" justify="center" center="xs">
            <Col xs={24} md={6}>
              <div className="mb-3">
                <Button
                  type="primary"
                  className="btn-block gtm_info-from-wp__loadmore"
                  value="large"
                  onClick={this.loadMore}C>次の3件を表示</Button>
              </div>
            </Col>
          </Row>
          */}
        </div>
        }
        <DimioSlidein
          fromRight={true}
          closeButton={true}
          width={window.innerWidth/2}
          ref={(ref) => {this.panel = ref}}
        >
          {selectedItem &&
          <CounsellingDetail item={selectedItem}/>
          }
        </DimioSlidein>

        {/*
        <DimioModal id='enquiry' appKey={this.props.appKey}>
          <ContactForm {...this.props} meta={{type: school.contact_type}}/>
        </DimioModal>
        */}
      </section>
    );
  }
}



export default connect(({ meta, school }) => ({
  meta, school
}))(CounsellingPage);



// WEBPACK FOOTER //
// ./src/pages/school/components/CounsellingPage.js